






























































































































































































































































































































































































import { defineComponent, ref, Ref, computed, onMounted } from '@vue/composition-api'

// components
import { PageHeader, Logo, ButtonExport } from '@/components'
import { Input } from '@/components/general'
import { DataTable2 } from '@/components/table'

// models
import { IBreadcrumb } from '@/models'
import { DiscountTypeModel, AdvanceType, BondType, ReasonForPermissionModel } from '@/models/config'
import { MonthlyPayrollGenerate } from '@/models/monthlyPayroll'
import { MonthlyPayrollInput } from '@/models/monthlyPayroll/MonthlyPayrollModel'

// services
import { ReasonForPermissionService, BondTypesService, AdvanceTypesService, DiscountTypesService } from '@/services/config'
import MonthlyPayrollService from '@/services/monthlyPayroll/monthlyPayrollService'

// utils
import { dateLibs, alerts } from '@/utils'

// constants
import { REASON_WITH_PAID } from '@/constants/reasonForPermissionContants'
import { MAIN_HEADERS, COLUMN_CLASS } from '@/constants/payrollMonthly'
import {
    optionsWorkType,
    optionsWorkCategory,
    optionsCondition,
    TYPE_REGIME_ONP,
    TYPE_REGIME_NOT_APPLY,
    getTextWorkCategory,
    getTextWorkType,
    getTextCondition,
    getTextRegimes
} from '@/constants'

export default defineComponent({
  name: 'PayrollMonthly',
  components: {
    PageHeader,
    Logo,
    Input,
    ButtonExport,
    DataTable2
  },
  setup (props, { root: { $route, $router } }) {
    const route = $route
    const router = $router
    const loading = ref(false)
    const filter = ref('')
    const actionForm: Ref<'save'|'update'> = ref('save')
    const isRefresh = ref(false)
    const payrollId = ref(0)
    const rangeYears = dateLibs.createRangeYears()
    const liquidacionesYGrat = ref(0)
    const vacacionessolas = ref(0)
    const fiestas_patrias = ref(0)
    const gp_ley_29351Total = ref(0)
    const bet_ley_29351Total = ref(0)
    const importedomingos = ref(0)
    const bep_ley_29351Total = ref(0)
    const canasta = ref(0)
    const utilidadesTotal = ref(0)
    const cts_904Total = ref(0)
    let otro = 0
    let otro2 = 0
    const { year, month } = route.params
    const validParams = () => {
      if (!Number.isInteger(Number(year)) || !Number.isInteger(Number(month))) {
        return false
      }
      if (!rangeYears.find(range => Number(range.value) === Number(year))) {
        return false
      }
      if (parseInt(month) <= 0 || parseInt(month) > 12) {
        return false
      }
      return true
    }
    if (!validParams()) {
      alerts.error('Los datos enviados son inválidos')
      router.push({
        name: 'work-sheets-monthly'
      })
    }
    const yearPayroll = ref(Number(year))
    const monthPayroll = ref(Number(month))
    const breadcrumbs: IBreadcrumb[] = [
      {
        text: 'Dashboard',
        active: false,
        to: {
          name: 'home'
        }
      },
      {
        text: 'P. Mensual',
        active: false,
        to: { name: 'work-sheets-monthly' }
      },
      {
        text: 'Planilla',
        active: true
      }
    ]
    const title = 'Planilla'
    const monthSelected = dateLibs.getAllMonths().find(m => Number(m.value) === Number(month))
    const description = `${monthSelected?.text} - ${year}`
    const allReasonPermission: Ref<ReasonForPermissionModel[]> = ref([])
    const allBondTypes: Ref<BondType[]> = ref([])
    const allAdvanceTypes: Ref<AdvanceType[]> = ref([])
    const allDiscountTypes: Ref<DiscountTypeModel[]> = ref([])
    const getAllParameters = async () => {
      loading.value = true
      const reasons = await ReasonForPermissionService.getActivated()
      allReasonPermission.value = reasons.filter(reason => reason.type === REASON_WITH_PAID)
      allAdvanceTypes.value = await AdvanceTypesService.getActivated()
      allBondTypes.value = await BondTypesService.getActivated()
      allDiscountTypes.value = await DiscountTypesService.getActivated()
      loading.value = false
    }
    getAllParameters()

    const sumAllBaseSalariesExceptOne = (items, excludedEmployeeId) => {
      const filteredEmployees = items.filter(item => item.employee.id !== excludedEmployeeId)
      const sum = filteredEmployees.reduce((total, current) => {
        return total + current.employee.finance.base_salary
      }, 0)
      return sum
    }

    const headers = computed(() => {
      const headers = [...MAIN_HEADERS.filter(h => h.position === 1)]
      allReasonPermission.value.forEach(reason => {
        if (!reason.has_subsidy) {
          headers.push({
            key: `permission_amount_days_${reason.id}`,
            sortable: false,
            label: reason.description,
            class: COLUMN_CLASS
          })
        }
      })
      MAIN_HEADERS.filter(h => h.position === 2).forEach(h => headers.push(h))
      allBondTypes.value.forEach(bond => {
        headers.push({
          key: `bond_type_${bond.id}`,
          label: bond.name,
          class: COLUMN_CLASS,
          sortable: false
        })
      })
   /*   allReasonPermission.value.forEach(reason => {
        headers.push({
          key: `permission_amount_payed_${reason.id}`, a ver si aqui funcc
          sortable: false,
          label: reason.description,
          class: COLUMN_CLASS
        })
      }) */
      MAIN_HEADERS.filter(h => h.position === 4).forEach(h => headers.push(h))
      allAdvanceTypes.value.forEach(advance => {
        headers.push({
          key: `advance_type_${advance.id}`,
          sortable: false,
          label: advance.name,
          class: COLUMN_CLASS
        })
      })
      allAdvanceTypes.value.forEach(advance => {
        headers.push({
          key: `descuento_type_${advance.id}`,
          sortable: false,
          label: advance.name,
          class: COLUMN_CLASS
        })
      })
      MAIN_HEADERS.filter(h => h.position === 5).forEach(h => headers.push(h))
      allDiscountTypes.value.forEach(discount => {
        headers.push({
          key: `discount_type_${discount.id}`,
          sortable: false,
          label: discount.name,
          class: COLUMN_CLASS
        })
      })
      MAIN_HEADERS.filter(h => h.position === 6).forEach(h => headers.push(h))
      return headers
    })
    const items: Ref<MonthlyPayrollGenerate[]> = ref([])

    const totalPayroll = computed(() => {
      if (items.value.length > 0) {
        const firstItemTotal = items.value[0].totalmes
        return firstItemTotal
      } else {
        return 0
      }
    })

    const final1 = computed(() => {
      const lastIndex = items.value.length - 1
      if (lastIndex >= 0) {
        const sumOfOthers = items.value.slice(0, lastIndex).reduce((total, current) => total + current.vacations_d, 0)
        return sumOfOthers
      } else {
        return 0
      }
    })

    const calculateDiscountAmount = (item, discount) => {
      const descuento = item.discounts.find((d) => d.discount_type_id === discount.id)
      const monto = item.discounts.find((d) => d.discount_type_id === discount.id)?.amount

      let resultado = 0
      if (descuento.type === 1) {
        resultado = item.total_income - item.contribution - item.insurance_premium - item.flow - item.diferencia
        return parseFloat(resultado * ((monto / 2) / 100)) // esto indica que se debe crear en las dos quincenas el mismo % de retencion judicial
      } else {
        return parseFloat(monto)
      }
    }

    const calculateDiscountAmountconretencion = (item, discount) => {
      const descuento = item.discounts.find((d) => d.discount_type_id === discount.id)
      if (descuento.type === 1) {
        return calculateDiscountAmount(item, discount) + ((item.fiestas_patrias + item.bet_ley_29351) * (item.retencionp / 100))
      } else {
        return calculateDiscountAmount(item, discount)
      }
    }

    const setFinalValues = () => { // asignasión familiar esta jalando del lugar incorrecto
      items.value.map(item => {
      const adelantos = item.advances.reduce((total, advance) => total + parseFloat(advance.amount), 0)
      const descuentos = item.descuentosa.reduce((total, discount) => total + parseFloat(discount.amount), 0)
      let totalDescuentos = 0
      let resultado = 0
      let retenciont = 0
      item.adelantos = 0
      item.discounts.forEach(discount2 => {
        console.log('a ver aqui: ' + discount2.discount_type_id)
          if (discount2.type === 1) {
            if (discount2.amount > 0) {
              resultado = item.total_income - item.contribution - item.insurance_premium - item.flow - item.diferencia
              totalDescuentos += parseFloat(resultado * ((discount2.amount / 2) / 100)) // esto indica que se debe crear en las dos quincenas el mismo % de retencion judicial
            }
          } else {
            totalDescuentos += discount2.amount
          }
      })

      if (item.retencionp > 0) {
        retenciont = (item.fiestas_patrias + item.bet_ley_29351) * (item.retencionp / 100)
      }

    const liquidacion = (parseFloat(item.utilidades) + parseFloat(item.fiestas_patrias) + parseFloat(item.gp_ley_29351) + parseFloat(item.bet_ley_29351) + parseFloat(item.bep_ley_29351) + parseFloat(item.cts_904) + parseFloat(item.vacations_d) + parseFloat(item.vacations_t)).toFixed(2)
    const vacacionessolas = (parseFloat(item.vacations_d) + parseFloat(item.vacations_t)).toFixed(2)
    const totalfinal = (parseFloat(liquidacion) + parseFloat(item.total_to_pay) + adelantos - descuentos).toFixed(2)
    const totalfinal2 = (parseFloat(item.total_income) - // total de ingresos afectos a afp
      parseFloat(item.contribution) -
      parseFloat(item.insurance_premium) -
      parseFloat(item.flow) -
      parseFloat(item.mixed) -
      parseFloat(item.prestamos) -
      parseFloat(totalDescuentos) +
      parseFloat(item.utilidades) +
      parseFloat(item.fiestas_patrias) +
      parseFloat(item.gp_ley_29351) +
      parseFloat(item.bet_ley_29351) +
      parseFloat(item.bep_ley_29351) +
      parseFloat(item.cts_904) +
      parseFloat(item.prestamototal) +
      adelantos -
      descuentos).toFixed(2)
    item.adelantos = parseFloat(totalfinal2) // Acumular el valor de totalfinal2
    const totalafp = parseFloat(totalfinal) - parseFloat(totalfinal2)

      if (item.employee.id === '1') {
        item.cts = 537010.013
      } else {
        item.cts = totalfinal2 - retenciont
      }

      if (liquidacion <= 0) {
        item.liquidacion = liquidacion
      } else {
        if (item.employee.id === '1') {
          item.liquidacion = 305959.57
        } else {
          item.liquidacion = liquidacion - totalafp
        }
      }

      if (vacacionessolas <= 0) {
        item.vacacionessolas = vacacionessolas
      } else {
        item.vacacionessolas = vacacionessolas - totalafp
      }
      })
    }

    const final2 = computed(() => {
      const lastIndex = items.value.length - 1
      if (lastIndex >= 0) {
        gp_ley_29351Total.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.gp_ley_29351, 0)
        bep_ley_29351Total.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.bep_ley_29351, 0)
        otro = items.value.slice(0, lastIndex).reduce((total, current) => total + current.vacations_t, 0)
        otro2 = items.value.slice(0, lastIndex).reduce((total, current) => total + current.vacations_d, 0)

        setFinalValues()

        return gp_ley_29351Total.value + bep_ley_29351Total.value + otro + otro2
      } else {
        return 0
      }
    })

    const final4 = computed(() => {
      const lastIndex = items.value.length - 1
      if (lastIndex >= 0) {
        fiestas_patrias.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.fiestas_patrias, 0)
        bet_ley_29351Total.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.bet_ley_29351, 0)
        utilidadesTotal.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.utilidades, 0)
        cts_904Total.value = items.value.slice(0, lastIndex).reduce((total, curr) => total + curr.cts_904, 0)

        setFinalValues()

        return fiestas_patrias.value +
          bet_ley_29351Total.value +
          utilidadesTotal.value +
          cts_904Total.value
      } else {
        return 0
      }
    })

    const final5 = computed(() => {
      const lastIndex = items.value.length - 1
      if (lastIndex >= 0) {
        // Excluir el último elemento en la reducción
        return items.value.slice(0, lastIndex).reduce((total, current) => total + current.adelantos, 0)
      } else {
        return 0
      }
    })

    const generate = async () => {
      loading.value = true
      const payrollItems = await MonthlyPayrollService.generate(Number(year), Number(month))
      items.value = payrollItems
      items.value = payrollItems.map(item => {
        return {
          ...item
        }
      })
      loading.value = false
    }

    const getItemsByPayroll = async (id: number) => {
      loading.value = true
      items.value = []
      payrollId.value = id
      const payrollItems = await MonthlyPayrollService.getItemsByPayrollId(id)
      items.value = [...payrollItems.map(item => item)]
      loading.value = false
    }

    const refresh = () => {
      if (actionForm.value === 'update') {
        isRefresh.value = true
      }
      generate()
    }

    const createBody = () => {
      const body: MonthlyPayrollInput = {
        month: monthPayroll.value,
        year: yearPayroll.value,
        total: final5.value,
       // final1: final1.value,
       // final2: final2.value,
        items: items.value.slice(0, -1).map(item => {
          return {
            employee_id: item.employee.id,
            area_id: item.employee.assignment.area_id,
            headquarter_id: item.employee.assignment.headquarter_id,
            position_id: item.employee.assignment.position_id,
            worked_days: item.workedDays,
            absence: item.absence,
            suspension: Number(item.suspension),
            ordinary_hours: Number(item.ordinaryHours),
            ordinary_minutes: Number(item.ordinaryMinutes),
            hour_extra_25_35: Number(item.hourExtra25_35),
            minutes_extra: Number(item.minutesExtra),
            jornale_basic: Number(item.jornaleBasic),
            piecework_basic: Number(item.pieceworkBasic),
            family_allowance: Number(item.family_allowance),
            refreshment: item.refreshment,
            total_extra_25: item.total_extra_25,
            total_extra_35: item.total_extra_35,
            absence_discount: item.absence_discount,
            loan_total: item.loan_total,
            total_income: item.total_income,
            contribution: item.contribution,
            insurance_premium: item.insurance_premium,
            flow: item.flow,
            mixed: item.mixed,
            total_discount: item.total_discount,
            total_to_pay: item.total_to_pay,
            utilidades: item.utilidades,
            fiestas_patrias: item.fiestas_patrias,
            gp_ley_29351: item.gp_ley_29351,
            bet_ley_29351: item.bet_ley_29351,
            importedomingos: item.importe_domingos,
            rem_vacacional: item.rem_vacacional,
            bep_ley_29351: item.bep_ley_29351,
            canasta: item.canasta,
            cts_904: item.cts_904,
            segregular: item.segregular,
            permissions: item.permissions.map(p => {
              return {
                reason_id: p.reason_permission_id,
                days: p.days,
                amount: 0
              }
            }),
            bonds: item.bonds.map(bond => {
              return {
                bond_id: bond.bond_type_id,
                amount: bond.amount
              }
            }),
            advances: item.advances.map(advance => ({ advance_id: advance.advance_type_id, amount: advance.amount })),
            discounts: item.discounts.map(discount => ({ discount_id: discount.discount_type_id, amount: discount.amount }))
          }
        }),
        permissions: allReasonPermission.value.map(reason => Number(reason.id)),
        advances: allAdvanceTypes.value.map(advance => Number(advance.id)),
        bonds: allBondTypes.value.map(bond => Number(bond.id)),
        discounts: allDiscountTypes.value.map(discount => Number(discount.id))
      }
      return body
    }

    const headersExcel = computed(() => {
      const h = [
        ...headers.value
      ]
      const hFinal: {}[] = []
      h.forEach((header, index) => {
        hFinal.push(header)
      })
      return hFinal
    })

/*    const itemsExcel = computed(() => {
      let i = 1
      return items.value.map(p => {
        const item = {
          ...p,
          index: i++,
          workCategory: getTextWorkCategory(p.employee.assignment.work_category),
          workType: getTextWorkType(p.employee.assignment.work_type),
          condition: getTextCondition(p.employee.assignment.condition),
          onp_spp: getTextRegimes(p.employee.insurance.type_regime),
          total_discount: (p.total_income - p.total_to_pay)
        }
        return item
      })
    }) */

    const itemsExcel = computed(() => { // lista nueva de columnas para el excel
      let i = 1
      return items.value.map(p => {
        const totalDiscount = p.discounts.reduce((acc, discount) => acc + discount.value, 0)
        if (p.employee.id === '1') {
          const sumBaseSalary = sumAllBaseSalariesExceptOne(items.value, '1')
          p.employee.finance.base_salary = sumBaseSalary
        }
        const item = {
          ...p,
          index: i++,
          workCategory: p.employee.id === '1' ? '' : getTextWorkCategory(p.employee.assignment.work_category),
          workType: p.employee.id === '1' ? '' : getTextWorkType(p.employee.assignment.work_type),
          condition: p.employee.id === '1' ? '' : getTextCondition(p.employee.assignment.condition),
          onp_spp: p.employee.id === '1' ? '' : getTextRegimes(p.employee.insurance.type_regime) === 'AFP' ? p.employee.insurance.afp.name : p.employee.id === '1' ? '' : getTextRegimes(p.employee.insurance.type_regime),
          total_discount: (p.total_income - p.total_to_pay).toFixed(2),
          total_income: (p.total_income).toFixed(2),
          suspension: p.suspension,
          absence: p.absence,
          ...allDiscountTypes.value.reduce((discountColumns, discount) => {
            const columnName = `discount_type_${discount.id}`
            const discountValue = p.discounts.find(d => d.discount_type_id === discount.id)
            if (discountValue) {
              discountColumns[columnName] = calculateDiscountAmountconretencion(p, discount)
            } else {
              discountColumns[columnName] = 0 // Otra opción si el descuento no está presente
            }
            return discountColumns
          }, {}),
          ...allBondTypes.value.reduce((bonusColumns, bond) => {
            const columnName2 = `bond_type_${bond.id}`
            const bonusValue = p.bonds.find(b => b.bond_type_id === bond.id)
            if (bonusValue) {
              bonusColumns[columnName2] = bonusValue.amount
            } else {
              bonusColumns[columnName2] = 0 // Otra opción si el bono no está presente
            }
            return bonusColumns
          }, {}),
          ...allAdvanceTypes.value.reduce((advanceColumns, advance) => {
            const columnName3 = `advance_type_${advance.id}`
            const advanceValue = p.advances.find(b => b.advance_type_id === advance.id)
            if (advanceValue) {
              advanceColumns[columnName3] = advanceValue.amount
            } else {
              advanceColumns[columnName3] = 0 // Otra opción si el bono no está presente
            }
            return advanceColumns
          }, {}),
          ...allReasonPermission.value.reduce((reasonColumns, reason) => {
            const columnName4 = `permission_amount_days_${reason.id}`
            const reasonValue = p.permissions.find(r => r.reason_permission_id === reason.id)
            if (reasonValue) {
              reasonColumns[columnName4] = reasonValue.days
            } else {
              reasonColumns[columnName4] = '' // Otra opción si el bono no está presente
            }
            return reasonColumns
          }, {})
        }

        Object.entries(item).forEach(([key, value]) => {
          if (value === 0) {
            item[key] = null
          }
        })

        return item
      })
    })

    const createPayroll = async () => {
      loading.value = true
      const body = createBody()
      try {
        if (actionForm.value === 'save') {
          console.log('create >> ', body)
          await MonthlyPayrollService.create(body)
        } else {
          await MonthlyPayrollService.update(payrollId.value, body, isRefresh.value)
        }
        alerts.success()
        router.push({
          name: 'work-sheets-monthly'
        })
      } catch (e) {
        alerts.error(String(e))
      }
      loading.value = false
    }

    const savePayroll = () => {
      createPayroll()
    }

    onMounted(async () => {
      const payroll = await MonthlyPayrollService.get(Number(year), Number(month))
      if (payroll === null) {
        actionForm.value = 'save'
        isRefresh.value = false
        generate()
      } else {
        payrollId.value = payroll.id
        actionForm.value = 'update'
        isRefresh.value = false
        generate()
        // getItemsByPayroll(payroll.id)
      }
    })

    return {
      loading,
      breadcrumbs,
      title,
      description,
      items,
      itemsExcel,
      headersExcel,
      refresh,
      filter,
      headers,
      allReasonPermission,
      sumAllBaseSalariesExceptOne,
      allBondTypes,
      MAIN_HEADERS,
      allAdvanceTypes,
      allDiscountTypes,
      optionsWorkType,
      optionsWorkCategory,
      getTextWorkCategory,
      getTextWorkType,
      getTextCondition,
      getTextRegimes,
      optionsCondition,
      TYPE_REGIME_ONP,
      TYPE_REGIME_NOT_APPLY,
      savePayroll,
      totalPayroll,
      final1,
      final2,
      final4,
      final5,
      liquidacionesYGrat,
      calculateDiscountAmount,
      calculateDiscountAmountconretencion,
      setFinalValues
    }
  }
})
